export default {
  baseErrorMessges: {
    required: "Este campo es obligatorio.",
    dataType: "Este campo no es del tipo correcto.",
    existingAsset: "Ya existe un activo con este identificador.",
    serialNoIsReq: "El número de serie es obligatorio.",
    length: "El valor de este campo debe ser",
    maxLength: "¡Se ha alcanzado el número máximo de caracteres disponibles para este campo!",
    min: "mínimo",
    max: "máximo",
    onlyNumbersOptionalCommaOrDot:
      "Por favor, tenga en cuenta el formato deseado. En este campo solo se permiten números y puntos decimales (¡debería redondearse a dos decimales por defecto)!",
    onlyIntegers: "Por favor, especifique el formato deseado. Solo se permiten números enteros en este campo!",
    lettersNumbersOnly:
      "Por favor, especifique el formato deseado. Solo se permiten números, letras y caracteres especiales en este campo!",
    guid: "Por favor, ajuste el formato deseado para el GUID. Se permiten números, letras de la a-f y guiones como en este ejemplo: 51d52cf1-83c9-4f02-b117-703ecb728b74",
  },
};
